import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import styles from './ResourceBlock.module.scss';
import ResourceBlockItem from './ResourceBlockItem';
const ResourceBlock = ({ $block, className }) => {
    if (!$block.data)
        return _jsx(_Fragment, {});
    return (_jsx("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: Object.entries($block.data).map(([fhirRef, resource]) => (_jsx(ResourceBlockItem, { "$block": $block, resource: resource }, fhirRef))) })));
};
export default observer(ResourceBlock);
